import { createContext } from 'react'
import { PROPOSAL_PHASE_TYPE } from '@vzmi/shp_shared_compo/constants/proposal'
import { PAGE_FLOW } from '../../../constants/proposalTypes'

export const FlowContext = createContext(null)

// 取得批次提案流程的狀態
export const getCurrentFlow = phase => {
  let currentFlow = ''
  switch (phase) {
    case PROPOSAL_PHASE_TYPE.COMPOSE:
      currentFlow = PAGE_FLOW.EDIT
      break
    default:
      break
  }
  return currentFlow
}

export const defaultFailedFlow = () => Promise.resolve(['flow not found', []])

export const defaultPassedFlow = () => Promise.resolve([null, true])
